<script setup lang="ts">
import { computed, type Component } from 'vue';
import type { SignatureGeneratorFragment } from '@pkg/types/signatureGenerator';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string,
    theme: string,
    signatureGeneratorFragment: SignatureGeneratorFragment,
    defaultPronouns: any;
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  theme: props.block?.theme,
  signatureGeneratorFragment: props.block?.signatureGeneratorFragment,
  defaultPronouns: props.block?.defaultPronouns[0]?.pronouns,
}));
</script>

<template>
  <component :is="props.config?.innerComponent" v-bind="data" />
</template>
